import { DisaggregatedMetric, MetricPanelProps } from "../../services/types";
import { getSortedMetrics, getSvgMap } from "../../utils/dashboardUtils";
import MetricCard from "../MetricCard";
import IndexBanner from "../IndexBanner";

const AccessibilityMetrics = ({ indicators, metadata, categorizedData, tab, geoDetails, geoTag, selectionActive }: MetricPanelProps) => {   
    const sortedMetrics = getSortedMetrics(tab, categorizedData);
    console.log("accessibility data:", sortedMetrics);

    let metricsForTab = indicators; // Get metrics for the current tab

    // Find the indexMetric from metadata based on the current tab
    const indexMetricId = metadata?.find((metric) => metric.metric_source_type === "index" && metric.metric_category.toLowerCase() === tab.toLowerCase())?.id || 0;

    // Find the full indicator object that matches indexMetric
    const indexMetricData = indicators.find(metric => metric.id === Number(indexMetricId)) || null;

    // Exclude the index metric from the list of metrics
    if (indexMetricId) {
        metricsForTab = metricsForTab.filter((metric) => metric.id !== indexMetricId);
    }

    if (!metricsForTab || metricsForTab.length === 0) {
        return <div className="flex items-center justify-center text-color-cai-dashboard">No metrics available for {tab}.</div>;
    }

    const accessibility: DisaggregatedMetric[] = sortedMetrics[0];

    return (
        <div className="h-screen">
            <div className="mb-2">
                <IndexBanner
                    key={indexMetricId}
                    metric={indexMetricData}
                    svg={undefined}
                    disaggData={indicators}
                    geoDetails={geoDetails}
                    geoTag={geoTag}
                    selectionActive={selectionActive}
                />
            </div>
            <p className="text-[10px] text-port-text mx-4">
            Activate the <span aria-hidden="true">🛈</span> <strong>button</strong> to expand additional information about a metric.
            </p>
            <p className="text-port-text mx-4 text-[10px]">Data updates published August 14, 2026.</p>
            <div className="mx-auto px-4 pb-8 pt-4">
                <div className="grid grid-cols-2 gap-4">
                    {accessibility.map(metric => (
                        <MetricCard
                            key={metric.id}
                            metric={metric}
                            width="w-full"
                            svg={getSvgMap(metric.id)}
                            disaggData={indicators}
                            geoDetails={geoDetails}
                            geoTag={geoTag}
                            selectionActive={selectionActive}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
}

export default AccessibilityMetrics;